import React from "react";

import styles from "./styles.module.css";

const Logo = () => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 154 68"
    className={styles.logo}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M154 50.984c0-3.578-2.882-6.477-6.441-6.477a6.437 6.437 0 00-6.055 4.259c1.224 5.23-2.013 10.443-7.198 11.673a7.601 7.601 0 01-1.031.178A39.099 39.099 0 00141.118 68a38.871 38.871 0 0012.109-13.924c.515-.939.773-2.008.773-3.092z"
      fill="#B02546"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M134.676 44.507c3.557 0 6.441 2.9 6.441 6.477 0 3.576-2.884 6.476-6.441 6.476s-6.441-2.9-6.441-6.476c0-3.577 2.884-6.477 6.441-6.477z"
      fill="#DD462C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M102.712 38.581c0-6.994 6.006-13.163 14.171-13.163 4.686 0 10.306 2.364 10.306 6.169 0 2.186-1.772 3.967-3.946 3.967-2.174 0-3.945-1.781-3.945-3.967s1.771-3.303 1.771-3.303a5.056 5.056 0 00-3.043-1.085c-3.897 0-6.779 4.793-6.779 10.12 0 5.326 2.882 10.135 6.779 10.135 0 0 4.493.227 8.051-2.93l.628 1.667c-3.945 5.683-9.838 5.537-9.838 5.537-8.149 0-14.155-6.185-14.155-13.147zM99.475 46.304V23.815h-1.771c-1.965 1.522-4.767 2.494-7.375 2.494h-2.206v1.78a2.818 2.818 0 012.85 2.802v15.398c.016 1.57-1.24 2.849-2.786 2.849h-.048v1.78h14.186v-1.78a2.818 2.818 0 01-2.85-2.801v-.033zM95.224 13c2.668 0 4.831 2.175 4.831 4.857 0 2.683-2.163 4.858-4.831 4.858-2.668 0-4.83-2.175-4.83-4.858 0-2.682 2.162-4.857 4.83-4.857zM88.122 28.09v-1.781h-5.2v-8.452H81.15c-1.272 4-5.508 8.452-11.723 8.452v1.78h2.141a2.805 2.805 0 012.835 2.802v16.433c0 .616.708 4.21 4.943 4.21 3.22 0 5.942-1.83 7.424-3.675l-.628-1.652s-1.144.486-1.788.486c-1.127 0-1.433-1.295-1.433-2.429V30.955a2.809 2.809 0 012.802-2.85h2.399v-.015z"
      fill="#252420"
    />
    <mask id="a" maskUnits="userSpaceOnUse" x="0" y="17" width="72" height="35">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 17.857h71.923v33.71H0v-33.71z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#a)" fillRule="evenodd" clipRule="evenodd" fill="#252420">
      <path d="M59.572 45.543v-8.548c-6.248 1.505-7.086 3.545-7.086 7.253 0 5.035 5.862 2.574 7.086 1.295zm-15.588-.42c0-2.203 1.143-5.1 3.446-6.38 3.945-2.153 10.338-2.882 12.142-3.546V32.3c0-3.902-2.255-5.1-4.445-5.1-2.19 0-4.122 1.538-4.122 1.538a3.967 3.967 0 011.207 2.85c-.048 2.186-1.851 3.934-4.025 3.886a3.962 3.962 0 01-3.865-3.886c0-4.469 7.134-6.169 12.126-6.169 11.336 0 11.626 4.874 11.626 8.76v10.086c0 1.134.306 2.429 1.433 2.429.644 0 1.788-.486 1.788-.486l.628 1.668s-2.738 3.675-7.408 3.675-4.943-4.226-4.943-4.226c-2.03 2.25-4.477 4.242-8.036 4.242-5.201 0-7.552-3.303-7.552-6.444zM28.235 50.935v-1.781c1.562.016 2.818-1.247 2.834-2.817V23.508L19.717 49.154h-1.772L7.092 24.674v21.63a2.809 2.809 0 002.802 2.85h.048v1.78H-.01v-1.78c1.546.016 2.818-1.247 2.834-2.801V22.504c.016-1.57-1.223-2.85-2.77-2.866H-.01v-1.78h13.398l7.762 17.534 7.761-17.535h13.51v1.781a2.805 2.805 0 00-2.833 2.801v23.849c-.016 1.57 1.24 2.85 2.785 2.85h.049v1.78l-14.187.017z" />
    </g>
  </svg>
);

export default Logo;
